import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { localized, msg, str } from '@lit/localize';
import style from './usos-spinner.scss'

/*  Based on https://projects.lukehaas.me/css-loaders/
    The MIT License (MIT)

    Copyright (c) 2014 Luke Haas

    Permission is hereby granted, free of charge, to any person obtaining a copy of
    this software and associated documentation files (the "Software"), to deal in
    the Software without restriction, including without limitation the rights to
    use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
    the Software, and to permit persons to whom the Software is furnished to do so,
    subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
    FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
    COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
    IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
    CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/**
 * Spinner providing animation for loading.
 */
@customElement('usos-spinner')
@localized()
export class UsosSpinner extends LitElement {
    static override styles = style;

    @property({attribute: 'aria-label', reflect: true}) override ariaLabel = '';

    /**
     * When set, the spinner scales to the current font size
     * instead of using its default large dimensions.
     */
    @property({reflect: true, type: Boolean}) inline = false;

    override render() {
        this.ariaLabel = msg(str`Ładowanie`);
        return html`
            <div>
                <div class='loader'></div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "usos-spinner": UsosSpinner,
    }
}
